import { render, staticRenderFns } from "./selectSegmentBasic.vue?vue&type=template&id=ed6659fe&"
import script from "./selectSegmentBasic.vue?vue&type=script&lang=js&"
export * from "./selectSegmentBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports